import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from '@blaze-react/modal';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import BlazeLink from '../../BlazeLink';
import { IN_VIEW_CONFIG } from '../../../constants';

// add for full screen modal based on blaze, and pass modifiers(lightbox)
const Lightbox = ({ name, imageUrl, altTxt, closeModal, imageCaption, imgWrapperProps }) => {
  const [isIntersecting, outerRef] = useInView(IN_VIEW_CONFIG);

  const hasLink = Object.keys(imgWrapperProps).length;
  const ImgWrapper = hasLink ? BlazeLink : Fragment;

  return (
    <Modal title={name} onClose={closeModal} isFullScreen>
      <div className="row row--display-row">
        <div className="column column--two-thirds">
          <div ref={outerRef} className="image">
            {isIntersecting && (
              <ImgWrapper {...imgWrapperProps} role={hasLink ? 'link' : ''}>
                <ResponsiveImage src={imageUrl} alt={altTxt} sizeKey="lightbox" />
              </ImgWrapper>
            )}
          </div>
        </div>
      </div>
      {imageCaption && (
        <div className="row row--display-row">
          <div className="caption">{imageCaption}</div>
        </div>
      )}
    </Modal>
  );
};

Lightbox.propTypes = {
  name: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  imgWrapperProps: PropTypes.object,
  imageUrl: PropTypes.string,
  imageCaption: PropTypes.string,
  altTxt: PropTypes.string,
  modifier: PropTypes.string
};

Lightbox.defaultProps = {
  name: '',
  imgWrapperProps: {},
  modifier: '',
  imageCaption: '',
  altTxt: '',
  imageUrl: ''
};

export default Lightbox;
